import React from "react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

// Layout condiviso delle pagine legali (privacy, cookie policy)
export const LegalPage = ({ eyebrow, title, updated, children, testId }) => (
  <div className="bg-obsidian text-cream min-h-screen">
    <Nav />
    <section className="pt-32 sm:pt-44 pb-24" data-testid={testId}>
      <div className="container-x max-w-3xl">
        <p className="eyebrow mb-3">{eyebrow}</p>
        <h1 className="font-serif font-semibold text-4xl sm:text-5xl leading-[1.05]">{title}</h1>
        {updated && <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-sand">Ultimo aggiornamento: {updated}</p>}
        <div className="mt-12 space-y-10">{children}</div>
      </div>
    </section>
    <Footer />
  </div>
);

export const LegalSection = ({ title, children }) => (
  <div>
    <h2 className="font-serif text-2xl text-cream mb-3">{title}</h2>
    <div className="space-y-3 text-sm sm:text-base text-cream2 leading-relaxed">{children}</div>
  </div>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2 pl-5 list-disc marker:text-copper">
    {items.map((it, i) => (
      <li key={i}>{it}</li>
    ))}
  </ul>
);
